import api from "../../utils/api/api.utils";
export var importPropertyPartnerWhise = function (whiseId) {
    return api.post("/properties/fetch-external-property", {
        data: {
            whiseEstateId: whiseId,
        },
    });
};
